import { render, staticRenderFns } from "./masterList.vue?vue&type=template&id=46b7d050&scoped=true"
import script from "./masterList.vue?vue&type=script&lang=js"
export * from "./masterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b7d050",
  null
  
)

export default component.exports